import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Create a root
root.render( // Use root.render instead of ReactDOM.render
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
